import * as React from "react";
import {Dispatch} from "redux";
import {logOut} from "../../store/action/user/user";
import {connect} from "react-redux";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import "./accessDisablePage.scss";

const logo = require('../../../resources/hiber/img/dg-logo-big-green.png');


interface IDispatchProps {
	/**
	 * Log out user action.
	 */
	logOut: () => void;
}

type Props = IDispatchProps;

class AccessDisablePage extends React.Component<Props, {}> {

	render() {
		return (
			<div className={"c-access-disable-page"}>
				<div className="c-access-disable-page_content">
					<img src={logo}/>
					<div className={"c-access-disable-page_content_text t-body"}>
						Access denied based on your permissions - please contact a dg administrator
					</div>
					<div>
						<ButtonPrimary label={"OK"}
									   onClick={this.props.logOut}/>
					</div>
				</div>
			</div>
		);
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		logOut: () => dispatch(logOut())
	}
}

export default connect(null, mapDispatchToProps)(AccessDisablePage);